import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import { Instagram } from 'blaze-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { GraduationCap } from 'blaze-ui/icons'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import Styles from './InstagramInitialization.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const InstagramNotice = () => {
  const openWindowSafely = useOpenWindowSafely()
  const connectionGuideLink = 'https://help.blaze.ai/en/articles/9556524-connect-blaze-to-instagram-business'

  const { isMobile } = useResponsiveDesign()

  return (
    <IntegrationNotice
      title="Instructions"
      message={
        <>
          <div className={Styles.numberedStep}>
            <div className={Styles.numberIcon}>1</div>
            <div className={Styles.stepContent}>
              <div className={Styles.stepParagraph}>
                Setup your Instagram Business Account and Facebook Business Page. Meta only allows Instagram Business
                Accounts that are connected to a Facebook Business page. Check your account settings to confirm.
              </div>
              <div className={Styles.note}>Note: Blaze cannot autopost to Creator or Personal accounts.</div>
              {isMobile ? null : (
                <div className={Styles.imagesContainer}>
                  <img
                    src="https://res.cloudinary.com/almanac/image/upload/v1763601592/blaze_assets/integrations/instagram_integration_1.png"
                    alt="Instagram Business Account setup step 1"
                  />
                  <img
                    src="https://res.cloudinary.com/almanac/image/upload/v1763601592/blaze_assets/integrations/instagram_integration_2.png"
                    alt="Instagram Business Account setup step 2"
                  />
                </div>
              )}
              <div className={Styles.buttonContainer}>
                <Button
                  variant="secondary"
                  frontIcon={GraduationCap}
                  size="sm"
                  onPress={() => openWindowSafely(connectionGuideLink)}
                >
                  See Setup Guide
                </Button>
              </div>
            </div>
          </div>
          <div className={Styles.numberedStep}>
            <div className={Styles.numberIcon}>2</div>
            <div className={Styles.stepContent}>
              <div className={Styles.stepParagraph}>
                Proceed below to authenticate through Facebook. We will redirect you to Facebook (Meta) to sign in
                and connect your account.
              </div>
            </div>
          </div>
        </>
      }
    />
  )
}

const InstagramInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost
    ? 'Set up your Instagram Business integration'
    : 'Connect Instagram Business Account'

  const sharedProps = {
    notice: <InstagramNotice />,
    providerName: 'Facebook (Meta)',
    onClose: closeModal,
    icon: <Instagram size={32} />,
    title,
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.Instagram),
    primaryButtonText: 'Go to Facebook Business',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default InstagramInitialization
